(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ed-product-plans"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ed-plans')) {
  customElements.define('ed-plans', class extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      const o = { signal: this.ac.signal };
      this.addEventListener('click', (e) => {
        const tab = e.target.closest('[data-set-tab]');
        if (tab) this.setTab(tab.dataset.setTab);
        const tier = e.target.closest('[data-set-tier]');
        if (tier) this.setTier(tier.dataset.setTier);
      }, o);
      this.addEventListener('change', (e) => {
        if (e.target.name === 'id') this.update(e.target, true);
      }, o);
      this.classList.add('is-ready');
      this.render();
    }
    disconnectedCallback() { this.ac?.abort(); }
    groups() { return [...this.querySelectorAll('.edp__group')]; }
    activeGroup() {
      const tab = this.dataset.tab;
      return this.groups().find((g) => g.dataset.group === tab && (tab === 'data' || g.dataset.tier === this.dataset.tier)) || this.groups()[0];
    }
    setTab(tab) { this.dataset.tab = tab; this.render(true); }
    setTier(tier) { this.dataset.tier = tier; this.render(true); }
    render(pick) {
      const hasTabs = !!this.querySelector('[data-set-tab]');
      if (!hasTabs && this.groups()[0]) this.dataset.tab = this.groups()[0].dataset.group;
      const active = this.activeGroup();
      for (const g of this.groups()) g.hidden = g !== active;
      for (const el of this.querySelectorAll('[data-unl-only]')) el.hidden = this.dataset.tab !== 'unl';
      for (const b of this.querySelectorAll('[data-set-tab]')) b.setAttribute('aria-pressed', String(b.dataset.setTab === this.dataset.tab));
      for (const b of this.querySelectorAll('[data-set-tier]')) b.setAttribute('aria-pressed', String(b.dataset.setTier === this.dataset.tier));
      if (!active) return;
      let input = active.querySelector('input[name="id"]:checked');
      if (!input && pick) {
        const remembered = active.dataset.last && active.querySelector(`input[value="${active.dataset.last}"]`);
        input = remembered || active.querySelector('.edp-badge--hot')?.closest('label')?.querySelector('input:not(:disabled)') || active.querySelector('input[name="id"]:not(:disabled)');
        if (input) input.checked = true;
      }
      if (input) this.update(input, !!pick);
    }
    update(input, userChange) {
      const group = input.closest('.edp__group');
      if (group) group.dataset.last = input.value;
      const title = this.querySelector('[data-sum-title]');
      const price = this.querySelector('[data-sum-price]');
      const name = this.querySelector('h1')?.textContent.replace(/\s*eSIM\s*$/, '') || '';
      if (title) title.textContent = `${name} · ${input.dataset.title}`;
      if (price) price.textContent = input.dataset.price;
      if (!userChange) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState(window.history.state, '', url);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
